import { jsx } from "react/jsx-runtime";
import { CarouselProvider } from "pure-react-carousel";
import { BalanceCarouselWrapper } from "./BalanceCarouselWrapper.mjs";
import "pure-react-carousel/dist/react-carousel.es.css";
import { carousel } from "./BalanceCarousel.css.mjs";
const BalanceCarousel = ({ balances }) => {
  const balanceCount = balances.length;
  return /* @__PURE__ */ jsx(
    CarouselProvider,
    {
      naturalSlideWidth: 584,
      naturalSlideHeight: 242,
      totalSlides: balanceCount,
      visibleSlides: 1,
      isIntrinsicHeight: true,
      className: carousel,
      children: /* @__PURE__ */ jsx(BalanceCarouselWrapper, { balances })
    }
  );
};
export {
  BalanceCarousel
};
